<lib-card>
  <ng-container title>Rapporto di Incoerenze</ng-container>
  <ng-container content>
    @if (incoherenceReport(); as report) {
      <div class="flex flex-col gap-5 pt-4">
        @if (report.overallAssessment) {
          <p class="text-base leading-relaxed text-slate-600">
            {{ report.overallAssessment }}
          </p>
        }

        @if (report.items.length) {
          <div class="flex flex-col gap-3">
            @for (item of report.items; track $index) {
              <div
                class="flex flex-col gap-2 rounded-xl border-l-4 bg-slate-50 px-4 py-3"
                [class]="
                  item.severity === 'High'
                    ? 'border-red-500'
                    : item.severity === 'Medium'
                      ? 'border-yellow-400'
                      : 'border-blue-400'
                "
              >
                <div class="flex items-start justify-between gap-3">
                  <span
                    class="text-sm font-semibold uppercase tracking-wide text-slate-500"
                  >
                    {{ item.questionLabel }}
                  </span>
                  <span
                    class="shrink-0 rounded-full px-2.5 py-0.5 text-sm font-bold uppercase"
                    [class]="
                      item.severity === 'High'
                        ? 'bg-red-100 text-red-700'
                        : item.severity === 'Medium'
                          ? 'bg-yellow-100 text-yellow-700'
                          : 'bg-blue-100 text-blue-700'
                    "
                  >
                    {{ item.severity }}
                  </span>
                </div>

                <p class="text-md m-0 leading-snug text-slate-800">
                  {{ item.issue }}
                </p>

                @if (item.suggestedFix) {
                  <div class="flex gap-2 rounded-lg bg-white px-3 py-2">
                    <i
                      class="pi pi-lightbulb mt-0.5 text-sm text-slate-400"
                    ></i>
                    <p class="m-0 text-sm leading-snug text-slate-500">
                      {{ item.suggestedFix }}
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-container>
</lib-card>
